import styled from "styled-components"


export const DSContainer = styled.div`
  justify-content: center;
  align-items: center;
  gap: 40px;
  display: inline-flex;
`;

export const DSDonutContainer = styled.div`
`;

export const DSDetailsontainer = styled.div`
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  display: inline-flex;
  width: 242px;
  gap: 8px;
`;
